import { motion } from "framer-motion";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";

const MainContent = () => {
  const { pathname } = useLocation();
  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    },
  };

  const pageTransition = {
    type: "tween",
    ease: "linear",
    duration: 0.2,
  };
  return (
    <div id="content" className="container-fluid pt-5 mt-3">
      <div className="main-container">
        <motion.div
          key={pathname}
          initial="initial"
          animate="in"
          variants={pageVariants}
          transition={pageTransition}
        >
          <Outlet />
        </motion.div>
      </div>
    </div>
  );
};

export default MainContent;
